import categoryIcon from '~/assets/icons/category.svg';
import foodIcon from '~/assets/icons/food.svg';
import otherIcon from '~/assets/icons/other_2.svg';
import {
	ProductShopItemCategory,
	ProductShopItemConfig,
	ProductShopType,
} from '~/shared';
import logo from '../../assets/images/logo.svg';
import touristLogo from '../../assets/images/tour.svg';

export const categoryNames: Record<ProductShopItemCategory, string> = {
	[ProductShopItemCategory.FOOD]: 'Еда',
	[ProductShopItemCategory.ITEMS]: 'Предметы',
	// [ProductShopItemCategory.FISH]: 'Рыба',
};

export const categoryIcons: Record<ProductShopItemCategory, string> = {
	[ProductShopItemCategory.FOOD]: foodIcon,
	[ProductShopItemCategory.ITEMS]: otherIcon,
};

export const allCategoriesIcon = categoryIcon;

export const shopLogos: Record<ProductShopType, string> = {
	[ProductShopType.EVERYDAY]: logo,
	[ProductShopType.TOURIST]: touristLogo,
	[ProductShopType.BAR]: 'Предметы',
};

export const getCategoriesFromItems = (items: ProductShopItemConfig[]) => {
	const uniqueCategories = new Set<ProductShopItemCategory>();

	items.forEach((item) => {
		uniqueCategories.add(item.category);
	});

	return Array.from(uniqueCategories).map((categoryId) => ({
		id: categoryId,
		name: categoryNames[categoryId],
		icon: categoryIcons[categoryId] ?? otherIcon,
	}));
};
